export default "__VITE_ASSET__CRhnpc06__"